import { render, staticRenderFns } from "./6.vue?vue&type=template&id=09ae9ed4&scoped=true&"
var script = {}
import style0 from "./6.vue?vue&type=style&index=0&id=09ae9ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae9ed4",
  null
  
)

export default component.exports